"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SwitcherButton = _interopRequireDefault(require("./SwitcherButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Switcher = function Switcher(_ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledSwitcher, _extends({
    className: className
  }, otherProps), children);
};

var StyledSwitcher = _styledComponents.default.div.withConfig({
  displayName: "StyledSwitcher"
})(["display:flex;justify-content:flex-start;align-items:center;border-radius:0.5rem;background:white;border:1px solid #f0f1f3;box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);overflow:hidden;> *{border-right:1px solid #f0f1f3;&:last-child{border-right:0;}}"]);

Switcher.propTypes = {
  /** Elements to be displayed inside the switcher. */
  children: _propTypes.node.isRequired,

  /** Extra classnames to be added to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
Switcher.SwitcherButton = _SwitcherButton.default;
Switcher.SwitcherButton.displayName = 'Switcher.SwitcherButton';
var _default = Switcher;
exports.default = _default;